export default __webpack_public_path__ + "static/media/ventrilla-res.9f0dbadd.jpg";